//@flow
import * as Immutable from 'immutable';
import ToastActions from 'common/redux/actions/toast';

const initialState = {
    records: {},
    counter: 0
};

const buildToast = (
    id: number,
    {
        message = '',
        subText = '',
        timeout = 3000,
        icon = null,
        type = null,
        ...others
    }
) => {
    return {
        id,
        message,
        subText,
        timeout,
        icon,
        type,
        ...others
    };
};

const incrementCounter = state => {
    return state.set('counter', state.get('counter') + 1);
};

const toastReducer = (
    state: Object = Immutable.fromJS(initialState),
    action: Object
): Object => {
    switch (action.type) {
        case ToastActions.SHOW_TOAST: {
            const updatedState = incrementCounter(state);
            const newCounter = state.get('counter');
            const toast = buildToast(newCounter, { ...action.payload });
            return updatedState.setIn(['records', newCounter], toast);
        }

        case ToastActions.UPDATE_TOAST: {
            const {
                params: { id },
                payload
            } = action;
            const toast = buildToast(id, payload);
            return state.setIn(['records', id], toast);
        }

        case ToastActions.HIDE_TOAST: {
            const { id } = action.params;
            return state.deleteIn(['records', id]);
        }
        case ToastActions.HIDE_TOASTS: {
            const { ids } = action.params;
            let newState = state;
            ids.forEach(idToDelete => {
                newState = newState.deleteIn(['records', idToDelete]);
            });
            return newState;
        }
        default:
            return state;
    }
};

export default toastReducer;
